import { render, staticRenderFns } from "./statusSelector.vue?vue&type=template&id=80c84280&"
import script from "./statusSelector.vue?vue&type=script&lang=ts&"
export * from "./statusSelector.vue?vue&type=script&lang=ts&"
import style0 from "./statusSelector.vue?vue&type=style&index=0&id=80c84280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports